// @ts-check
import { generateId } from "ai"

/**
 * @param {unknown} raw
 * @returns {import("ai").UIMessage[]}
 */
export function normalizeStoredUIMessages(raw) {
  if (!Array.isArray(raw)) return []
  /** @type {import("ai").UIMessage[]} */
  const out = []
  for (const item of raw) {
    if (!item || typeof item !== "object") continue
    const o = /** @type {Record<string, unknown>} */ (item)
    const role = o.role
    if (role !== "user" && role !== "assistant") continue
    const id = typeof o.id === "string" ? o.id : generateId()
    let parts = o.parts
    if (!Array.isArray(parts)) {
      const content = o.content
      if (typeof content === "string") {
        parts = [{ type: "text", text: content }]
      } else {
        parts = []
      }
    }
    out.push(
      /** @type {import("ai").UIMessage} */ ({
        ...o,
        id,
        role,
        parts,
      })
    )
  }
  return out
}
